export default "__VITE_ASSET__1zKt1p8w__"